<woa-quantity-control [decrementUnavailable]="!canDecrement()" (onDecrement)="decrementQuantity()"
                      [incrementUnavailable]="!canIncrement()" (onIncrement)="incrementQuantity()"
                      [quantity]="orderItem().quantitySignal()" [readOnly]="!!orderItem().dealIdSignal()"
                      [transparent]="transparent()"></woa-quantity-control>
